/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageFragment} from '@amblique/contentful/app/contentful/fragments/page/base-page.fragment';
import {AccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/accordion.fragment';
import {AccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/accordion-panel.fragment';
import {BlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/blog.fragment';
import {BlogGridFragment} from '@amblique/contentful/app/contentful/fragments/blog-grid/blog-grid.fragment';
import {BlogListingFragment} from '@amblique/contentful/app/contentful/fragments/blog-listing/blog-listing.fragment';
import {BlogRelatedArticlesFragment} from '@amblique/contentful/app/contentful/fragments/blog-related-articles/blog-related-articles.fragment';
import {BreadcrumbFragment} from '@amblique/contentful/app/contentful/fragments/breadcrumb/breadcrumb.fragment';
import {CardFragment} from '@amblique/contentful/app/contentful/fragments/card/card.fragment';
import {CarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/carousel.fragment';
import {CategoryCardGridFragment} from '@amblique/contentful/app/contentful/fragments/category-card-grid/category-card-grid.fragment';
import {ContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/container.fragment';
import {DescriptionBlockFragment} from '@amblique/contentful/app/contentful/fragments/description-block/description-block.fragment';
import {EditorialWrapperFragment} from '@amblique/contentful/app/contentful/fragments/editorial-wrapper/editorial-wrapper.fragment';
import {EmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/embed-panel.fragment';
import {FeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/feature-list.fragment';
import {FeaturedInWithLogosCf052Fragment} from '@amblique/contentful/app/contentful/fragments/featured-in-with-logos-cf052/featured-in-with-logos-cf052.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {IconSetFragment} from '@amblique/contentful/app/contentful/fragments/icon-set/icon-set.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {KingDifferenceMediaCf013Fragment} from '@amblique/contentful/app/contentful/fragments/king-difference-media-cf013/king-difference-media-cf013.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {LoopingTickerFragment} from '@amblique/contentful/app/contentful/fragments/looping-ticker/looping-ticker.fragment';
import {MediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/media-carousel.fragment';
import {MediaContentSectionFragment} from '@amblique/contentful/app/contentful/fragments/media-content-section/media-content-section.fragment';
import {MediaWithScrollableTextFragment} from '@amblique/contentful/app/contentful/fragments/media-with-scrollable-text/media-with-scrollable-text.fragment';
import {ProductTilesFragment} from '@amblique/contentful/app/contentful/fragments/product-tiles/product-tiles.fragment';
import {ReviewsFragment} from '@amblique/contentful/app/contentful/fragments/reviews/reviews.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';
import {SeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/seo.fragment';
import {ShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/shop-the-look.fragment';
import {ShowroomDetailsFragment} from '@amblique/contentful/app/contentful/fragments/showroom-details/showroom-details.fragment';
import {SplitHeadingFragment} from '@amblique/contentful/app/contentful/fragments/split-heading/split-heading.fragment';
import {SplitPanelDoubleImageBlockFragment} from '@amblique/contentful/app/contentful/fragments/split-panel-double-image-block/split-panel-double-image-block.fragment';
import {TeaserTileBlockFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile-block/teaser-tile-block.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullPageFragment = gql`
  ${AccordionFragment}
  ${AccordionPanelFragment}
  ${BasePageFragment}
  ${BlogFragment}
  ${BlogGridFragment}
  ${BlogListingFragment}
  ${BlogRelatedArticlesFragment}
  ${BreadcrumbFragment}
  ${CardFragment}
  ${CarouselFragment}
  ${CategoryCardGridFragment}
  ${ContainerFragment}
  ${DescriptionBlockFragment}
  ${EditorialWrapperFragment}
  ${EmbedPanelFragment}
  ${FeatureListFragment}
  ${FeaturedInWithLogosCf052Fragment}
  ${HeroBannerFragment}
  ${IconSetFragment}
  ${ImageFragment}
  ${KingDifferenceMediaCf013Fragment}
  ${LinkFragment}
  ${LoopingTickerFragment}
  ${MediaCarouselFragment}
  ${MediaContentSectionFragment}
  ${MediaWithScrollableTextFragment}
  ${ProductTilesFragment}
  ${ReviewsFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}
  ${SeoFragment}
  ${ShopTheLookFragment}
  ${ShowroomDetailsFragment}
  ${SplitHeadingFragment}
  ${SplitPanelDoubleImageBlockFragment}
  ${TeaserTileBlockFragment}
  ${VideoFragment}

  fragment FullPageFragment on Page {
    ...BasePageFragment

    mainRegionCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on AccordionPanel {
          ...AccordionPanelFragment
        }
        ... on Blog {
          ...BlogFragment
        }
        ... on BlogGrid {
          ...BlogGridFragment
        }
        ... on BlogListing {
          ...BlogListingFragment
        }
        ... on BlogRelatedArticles {
          ...BlogRelatedArticlesFragment
        }
        ... on Breadcrumb {
          ...BreadcrumbFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on CategoryCardGrid {
          ...CategoryCardGridFragment
        }
        ... on Container {
          ...ContainerFragment
        }
        ... on DescriptionBlock {
          ...DescriptionBlockFragment
        }
        ... on EditorialWrapper {
          ...EditorialWrapperFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on FeaturedInWithLogosCf052 {
          ...FeaturedInWithLogosCf052Fragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on IconSet {
          ...IconSetFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on KingDifferenceMediaCf013 {
          ...KingDifferenceMediaCf013Fragment
        }
        ... on Link {
          ...LinkFragment
        }
        ... on LoopingTicker {
          ...LoopingTickerFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on MediaContentSection {
          ...MediaContentSectionFragment
        }
        ... on MediaWithScrollableText {
          ...MediaWithScrollableTextFragment
        }
        ... on ProductTiles {
          ...ProductTilesFragment
        }
        ... on Reviews {
          ...ReviewsFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on ShopTheLook {
          ...ShopTheLookFragment
        }
        ... on ShowroomDetails {
          ...ShowroomDetailsFragment
        }
        ... on SplitHeading {
          ...SplitHeadingFragment
        }
        ... on SplitPanelDoubleImageBlock {
          ...SplitPanelDoubleImageBlockFragment
        }
        ... on TeaserTileBlock {
          ...TeaserTileBlockFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
    mainRegionCursorCollection {
      items {
        __typename
        ... on Accordion {
          ...AccordionFragment
        }
        ... on AccordionPanel {
          ...AccordionPanelFragment
        }
        ... on Blog {
          ...BlogFragment
        }
        ... on BlogGrid {
          ...BlogGridFragment
        }
        ... on BlogListing {
          ...BlogListingFragment
        }
        ... on BlogRelatedArticles {
          ...BlogRelatedArticlesFragment
        }
        ... on Breadcrumb {
          ...BreadcrumbFragment
        }
        ... on Card {
          ...CardFragment
        }
        ... on Carousel {
          ...CarouselFragment
        }
        ... on CategoryCardGrid {
          ...CategoryCardGridFragment
        }
        ... on Container {
          ...ContainerFragment
        }
        ... on DescriptionBlock {
          ...DescriptionBlockFragment
        }
        ... on EditorialWrapper {
          ...EditorialWrapperFragment
        }
        ... on EmbedPanel {
          ...EmbedPanelFragment
        }
        ... on FeatureList {
          ...FeatureListFragment
        }
        ... on FeaturedInWithLogosCf052 {
          ...FeaturedInWithLogosCf052Fragment
        }
        ... on HeroBanner {
          ...HeroBannerFragment
        }
        ... on IconSet {
          ...IconSetFragment
        }
        ... on Image {
          ...ImageFragment
        }
        ... on KingDifferenceMediaCf013 {
          ...KingDifferenceMediaCf013Fragment
        }
        ... on Link {
          ...LinkFragment
        }
        ... on LoopingTicker {
          ...LoopingTickerFragment
        }
        ... on MediaCarousel {
          ...MediaCarouselFragment
        }
        ... on MediaContentSection {
          ...MediaContentSectionFragment
        }
        ... on MediaWithScrollableText {
          ...MediaWithScrollableTextFragment
        }
        ... on ProductTiles {
          ...ProductTilesFragment
        }
        ... on Reviews {
          ...ReviewsFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
        ... on ShopTheLook {
          ...ShopTheLookFragment
        }
        ... on ShowroomDetails {
          ...ShowroomDetailsFragment
        }
        ... on SplitHeading {
          ...SplitHeadingFragment
        }
        ... on SplitPanelDoubleImageBlock {
          ...SplitPanelDoubleImageBlockFragment
        }
        ... on TeaserTileBlock {
          ...TeaserTileBlockFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
    seo {
      ...SeoFragment
    }
  }
`;
